import { render, staticRenderFns } from "./PageEntregaDetalleChip2.vue?vue&type=template&id=4b45cfb8&"
import script from "./PageEntregaDetalleChip2.vue?vue&type=script&lang=js&"
export * from "./PageEntregaDetalleChip2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports